var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3717 4C11.8233 4 13 5.1959 13 6.67112V13.3289C13 14.8041 11.8233 16 10.3717 16H3.62833C2.17674 16 1 14.8041 1 13.3289V6.67112C1 5.1959 2.17674 4 3.62833 4H10.3717Z",
    fill: "#567FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.705 6.43437L14.705 7.68437C14.2664 7.95848 14 8.43919 14 8.95637V11.0436C14 11.5608 14.2664 12.0415 14.705 12.3156L16.705 13.5656C17.7041 14.19 19 13.4718 19 12.2936V7.70637C19 6.52822 17.7041 5.80995 16.705 6.43437Z",
    fill: "#567FFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClass);
export default __webpack_public_path__ + "static/media/live-class.3b61e4b3354f0fe329ea7314728fb8dc.svg";
export { ForwardRef as ReactComponent };